"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AadSet = exports.globalVars = exports.Locale = exports.TOOLS = void 0;
exports.setTools = setTools;
exports.setLocale = setLocale;
exports.ErrorContextMW = ErrorContextMW;
exports.resetErrorContext = resetErrorContext;
exports.setErrorContext = setErrorContext;
exports.createContext = createContext;
function setTools(tools) {
    exports.TOOLS = tools;
}
function setLocale(locale) {
    exports.Locale = locale;
}
class GlobalVars {
    isVS = false;
    teamsAppId = "";
    m365TenantId = "";
    trackingId;
    ymlFilePath;
    envFilePath;
    //properties for error telemetry
    stage = "";
    source = "";
    component = "";
    method = "";
}
exports.globalVars = new GlobalVars();
function ErrorContextMW(option) {
    return async (ctx, next) => {
        option.method = ctx.method;
        setErrorContext(option);
        await next();
        if (option.reset) {
            resetErrorContext();
        }
    };
}
function resetErrorContext() {
    exports.globalVars.stage = "";
    exports.globalVars.source = "";
    exports.globalVars.component = "";
    exports.globalVars.method = "";
}
function setErrorContext(option) {
    if (option.reset) {
        resetErrorContext();
    }
    exports.globalVars.component = option.component || exports.globalVars.component;
    exports.globalVars.source = option.source || exports.globalVars.source;
    exports.globalVars.stage = option.stage || exports.globalVars.stage;
    exports.globalVars.method = option.method || exports.globalVars.method;
}
function createContext() {
    const context = {
        userInteraction: exports.TOOLS.ui,
        logProvider: exports.TOOLS.logProvider,
        telemetryReporter: exports.TOOLS.telemetryReporter,
        tokenProvider: exports.TOOLS.tokenProvider,
    };
    return context;
}
exports.AadSet = new Set();
//# sourceMappingURL=globalVars.js.map